import type { UserReviews } from '@ecg-marktplaats/reviews-dialog-ui';

const getDisplayReviewData = (reviewData: UserReviews | undefined) => {
  const displayReviewData = {
    averageScore: 0,
    numberOfReviews: 0,
    withReviewAttribution: false,
  };

  if (!reviewData) {
    return displayReviewData;
  }

  displayReviewData.averageScore = reviewData.rating ?? 0;
  displayReviewData.numberOfReviews = reviewData.numberOfReviews ?? 0;
  displayReviewData.withReviewAttribution = reviewData.reviewSystem === 'GOOGLE_REVIEWS';

  return displayReviewData;
};

export default getDisplayReviewData;
